module.exports = __webpack_public_path__ + "static/media/comcast.ef753126.png";